module.exports = __webpack_public_path__ + "img/img-servidor.061fa753.png";